import React, { useState } from "react";
import DeliverCard from "../cards/DeliverCard";
import PaymentCard from "../cards/PaymentCard";
import Repair from "../cards/Repair";
import BigChoiceCard from "../cards/BigChoiceCard";


// Style \\
import "../../assets/styles/parts/serviceGroup.scss";


// Icons \\
// import { TbTruckDelivery } from "react-icons/tb";

const ServiceGroup = () => {
  const [openFreeCheckModal, setOpenFreeCheckModal] = useState(true);
  const [openCardioModal, setOpenCardioModal] = useState(false);
  const [openDNA, setOpenDNA] = useState(false);
  const [openBloodBank, setopenbloodBank] = useState(false);
  // const [openDermology, setOpenDermology] = useState(false);
  // const [openOrthopedic, setOpenOrthopedic] = useState(false);

  const freeCheckBox = document.querySelector(".freeCheckBox");

  const aboutServices = () => {
    setOpenFreeCheckModal(true);
    if (setOpenFreeCheckModal(true)) {
      console.log(freeCheckBox);
    }
    setOpenCardioModal(false);
    setOpenDNA(false);
    setopenbloodBank(false);
  };

  const aboutCardioServices = () => {
    setOpenFreeCheckModal(false);
    setOpenCardioModal(true);
    setOpenDNA(false);
    setopenbloodBank(false);
  };

  const aboutDna = () => {
    setOpenFreeCheckModal(false);
    setOpenCardioModal(false);
    setOpenDNA(true);
    setopenbloodBank(false);
  };

  const aboutBloodBank = () => {
    setOpenFreeCheckModal(false);
    setOpenCardioModal(false);
    setOpenDNA(false);
    setopenbloodBank(true);
  };

  return (
    <div>
      <div className="aboutService_items">
        <div className="buttons_box ">
          <button
            onClick={aboutServices}
            className={` ${openFreeCheckModal ? "active" : ""}`}
          >
            <div className="img">
              <svg
                width="74"
                height="74"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path
                  d="M8.96456 18C8.72194 19.6961 7.26324 21 5.5 21C3.73676 21 2.27806 19.6961 2.03544 18H1V6C1 5.44772 1.44772 5 2 5H16C16.5523 5 17 5.44772 17 6V8H20L23 12.0557V18H20.9646C20.7219 19.6961 19.2632 21 17.5 21C15.7368 21 14.2781 19.6961 14.0354 18H8.96456ZM15 7H3V15.0505C3.63526 14.4022 4.52066 14 5.5 14C6.8962 14 8.10145 14.8175 8.66318 16H14.3368C14.5045 15.647 14.7296 15.3264 15 15.0505V7ZM17 13H21V12.715L18.9917 10H17V13ZM17.5 19C18.1531 19 18.7087 18.5826 18.9146 18C18.9699 17.8436 19 17.6753 19 17.5C19 16.6716 18.3284 16 17.5 16C16.6716 16 16 16.6716 16 17.5C16 17.6753 16.0301 17.8436 16.0854 18C16.2913 18.5826 16.8469 19 17.5 19ZM7 17.5C7 16.6716 6.32843 16 5.5 16C4.67157 16 4 16.6716 4 17.5C4 17.6753 4.03008 17.8436 4.08535 18C4.29127 18.5826 4.84689 19 5.5 19C6.15311 19 6.70873 18.5826 6.91465 18C6.96992 17.8436 7 17.6753 7 17.5Z"
                  fill="rgba(98, 56, 17, 0.888)"
                ></path>
              </svg>
            </div>
            <div className="field">
              <h3>Delivery and Installation</h3>
            </div>
          </button>

          <button
            onClick={aboutCardioServices}
            className={`${openCardioModal ? "active" : ""}`}
          >
            <div className="img">
              <svg
                width="74"
                height="74"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12.0049 22.0027C6.48204 22.0027 2.00488 17.5256 2.00488 12.0027C2.00488 6.4799 6.48204 2.00275 12.0049 2.00275C17.5277 2.00275 22.0049 6.4799 22.0049 12.0027C22.0049 17.5256 17.5277 22.0027 12.0049 22.0027ZM12.0049 20.0027C16.4232 20.0027 20.0049 16.421 20.0049 12.0027C20.0049 7.58447 16.4232 4.00275 12.0049 4.00275C7.5866 4.00275 4.00488 7.58447 4.00488 12.0027C4.00488 16.421 7.5866 20.0027 12.0049 20.0027ZM8.50488 14.0027H14.0049C14.281 14.0027 14.5049 13.7789 14.5049 13.5027C14.5049 13.2266 14.281 13.0027 14.0049 13.0027H10.0049C8.62417 13.0027 7.50488 11.8835 7.50488 10.5027C7.50488 9.12203 8.62417 8.00275 10.0049 8.00275H11.0049V6.00275H13.0049V8.00275H15.5049V10.0027H10.0049C9.72874 10.0027 9.50488 10.2266 9.50488 10.5027C9.50488 10.7789 9.72874 11.0027 10.0049 11.0027H14.0049C15.3856 11.0027 16.5049 12.122 16.5049 13.5027C16.5049 14.8835 15.3856 16.0027 14.0049 16.0027H13.0049V18.0027H11.0049V16.0027H8.50488V14.0027Z"
                  fill="rgba(98, 56, 17, 0.888)"
                ></path>
              </svg>
            </div>
            <div className="field">
              <h3>Easy Payment</h3>
            </div>
          </button>

          <button onClick={aboutDna} className={` ${openDNA ? "active" : ""} `}>
            <div className="img">
              <svg
                width="74"
                height="74"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path
                  d="M3.78307 2.82598L12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598ZM5 4.60434V13.7889C5 15.1263 5.6684 16.3752 6.7812 17.1171L12 20.5963L17.2188 17.1171C18.3316 16.3752 19 15.1263 19 13.7889V4.60434L12 3.04879L5 4.60434Z"
                  fill="rgba(98, 56, 17, 0.888)"
                ></path>
              </svg>
            </div>
            <div className="field">
              <h3>Guarantee</h3>
            </div>
          </button>

          <button
            onClick={aboutBloodBank}
            className={`${openBloodBank ? "active" : ""}`}
          >
            <div className="img">
              <svg
                width="74"
                height="74"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path
                  d="M6.99979 7V3C6.99979 2.44772 7.4475 2 7.99979 2H20.9998C21.5521 2 21.9998 2.44772 21.9998 3V16C21.9998 16.5523 21.5521 17 20.9998 17H17V20.9925C17 21.5489 16.551 22 15.9925 22H3.00728C2.45086 22 2 21.5511 2 20.9925L2.00276 8.00748C2.00288 7.45107 2.4518 7 3.01025 7H6.99979ZM8.99979 7H15.9927C16.549 7 17 7.44892 17 8.00748V15H19.9998V4H8.99979V7ZM15 9H4.00255L4.00021 20H15V9ZM8.50242 18L4.96689 14.4645L6.3811 13.0503L8.50242 15.1716L12.7451 10.9289L14.1593 12.3431L8.50242 18Z"
                  fill=" rgba(98, 56, 17, 0.888)"
                ></path>
              </svg>
            </div>
            <div className="field">
              <h3>Wide Selection</h3>
            </div>
          </button>
        </div>

        <div className="cards_box">
          {openFreeCheckModal && <DeliverCard />}
          {openCardioModal && <PaymentCard />}
          {openDNA && <Repair />}
          {openBloodBank && <BigChoiceCard />}
        </div>
      </div>
    </div>
  );
};

export default ServiceGroup;
